module.exports = __webpack_public_path__ + "media/images/favicons/favicon-tuesday-16x16-2decfbf205c4b873ebd61922cbc0477e.png";